//#region IMPORT
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import { PropTypes } from 'prop-types';
import dayjs from 'dayjs';
import HAZ_BASIC_01F from '../HAZ_BASIC_01/HAZ_BASIC_01F';
import HAZ_BASIC_02F from '../HAZ_BASIC_02/HAZ_BASIC_02F';
import HAZ_BASIC_03F from '../HAZ_BASIC_03/HAZ_BASIC_03F';
import { AuthButton } from '../../../../Components/MUIs';
import { setYear } from '../../../../Reducer/SearchReducer';

//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ height: '100%', width: '100%', minHeight: 0 }}>
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function HAZ_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="HazardousMachines"
          searchYn="Y"
          addYn={props.value === 0 ? 'N' : 'Y'}
          saveYn="Y"
          deleteYn="Y"
          printYn="N"
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            // SearchReducer는 별도로 관리되므로 여기서는 필터만 처리
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            } else if (props.value === 2) {
              props.setFilterClick3(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            } else if (props.value === 2) {
              props.setSaveClick3(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            } else if (props.value === 2) {
              props.setPrintClick3(true);
            }
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo?.coList || [],
                    value: searchInfo?.coCd || '',
                    onChange: async (e) => {
                      await props.handleCoChange(e);

                      if (props.value === 0) {
                        await props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        await props.setSearchClick2(true);
                      } else if (props.value === 2) {
                        await props.setSearchClick3(true);
                      }
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo?.custList || [],
              value: searchInfo?.custCd || '',
              onChange: async (e) => {
                await props.handleCustChange(e);

                if (props.value === 0) {
                  await props.setSearchClick1(true);
                } else if (props.value === 1) {
                  await props.setSearchClick2(true);
                } else if (props.value === 2) {
                  await props.setSearchClick3(true);
                }
              },
            },
            ...(props.value === 2
              ? [
                  {
                    type: 'datePicker',
                    views: ['year'],
                    openTo: 'year',
                    title: '연도',
                    name: '조회연도',
                    value: searchInfo?.year
                      ? dayjs(`${searchInfo.year}`, 'YYYY')
                      : dayjs(),
                    onChange: async (date) => {
                      if (date) {
                        const changeYear = dayjs(date).format('YYYY');
                        dispatch(setYear(changeYear));
                        if (props.value === 2) {
                          await props.setSearchClick3(true);
                        }
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY',
                  },
                ]
              : []),
          ]}
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="안전검사"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="안전인증 및 자율안전확인신고"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="계측기"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <HAZ_BASIC_01F
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <HAZ_BASIC_02F
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={2}>
                <HAZ_BASIC_03F
                  filterClick3={props.filterClick3}
                  setFilterClick3={props.setFilterClick3}
                  searchClick3={props.searchClick3}
                  setSearchClick3={props.setSearchClick3}
                  addClick3={props.addClick3}
                  setAddClick3={props.setAddClick3}
                  saveClick3={props.saveClick3}
                  setSaveClick3={props.setSaveClick3}
                  deleteClick3={props.deleteClick3}
                  setDeleteClick3={props.setDeleteClick3}
                  printClick3={props.printClick3}
                  setPrintClick3={props.setPrintClick3}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default HAZ_BASIC;
